import { render, staticRenderFns } from "./projectManagement.vue?vue&type=template&id=2a84efa8&scoped=true"
import script from "./projectManagement.vue?vue&type=script&lang=js"
export * from "./projectManagement.vue?vue&type=script&lang=js"
import style0 from "./projectManagement.vue?vue&type=style&index=0&id=2a84efa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84efa8",
  null
  
)

export default component.exports